import React, { Component } from 'react';

class EmailForm extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }


  render() {
    const { onUserEmailChange, onFriendEmailChange, userEmail, friendEmail } = this.props;
    return (
      <div>
        <form
          style={{ maxWidth: '400px', position: 'relative' }}
          onSubmit={{}}
          className="form__admin  form__admin--greyBg  u-padding-small"
        >

          <fieldset className="form__group  u-w-100">
            <input
              className="form__group__inputFields  u-border-box"
              value={userEmail}
              onChange={onUserEmailChange}
              id="orderid"
              placeholder={'Enter your email address'}
              required
            />
          </fieldset>

          <fieldset className="form__group  u-w-100  u-padding-bottom-small">
            <input
              className="form__group__inputFields  u-border-box"
              value={friendEmail}
              onChange={onFriendEmailChange}
              id="orderid"
              placeholder={'Enter your friends email address'}
              required
            />
          </fieldset>

        </form>
      </div>
    );
  }


}


export default EmailForm;



// WEBPACK FOOTER //
// ./src/cards/templates/RecommendAFriendCard/EmailForm.js